import React, { useEffect, useState } from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import { Header } from 'pages/Header';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { Footer } from 'pages/Footer';
import { MenuCredito } from 'components/menuCredito';
import { BASE_PATH } from 'constants/general';

export default function SinCreditoAutorizado({ creditoAutorizado }) {

    const { isMobile } = useIsMobile();

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Crédito Claroshop"} type="backFull" />
                : null
            }

            <div className="container">
                <div className="contCards">

                    <MenuCredito />

                    <div className="contArrayCards">
                        {/* {isMobile
                            ? isMobile === 'desktop' &&
                            <h1 className="h1AC">Solicitud de Crédito Claroshop</h1>
                            : null
                        } */}


                        <div className={isMobile === "desktop" ? "formasPagoTienda boderHome": 'formasPagoTienda'}>
                            <div className=''>
                                <img src="/credito-claroshop/img/tarjeta_de_credito_1.svg" alt="icon-credito-cs"></img>
                            </div>
                            <div className=''>
                                <h1 className='bold marginTop30'>Aún no tienes crédito Claroshop preautorizado</h1>

                                <p className='marginTop30'>Pronto lanzaremos la opción para que puedas solicitarlo.</p>

                                <div className='marginTop30 marginBottom35'>
                                    <h1 className='boldmarginTop10'>Si te llego una invitación recuerda loguearte con ese correo.</h1>
                                </div>

                                {isMobile && isMobile !== 'desktop' &&
                                    <div className='marginTop50'>
                                        <a href={`${BASE_PATH}`} className='btn rojo marginTop50'>Seguir navegando</a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isMobile === 'desktop'
                ? <Footer type="complete" />
                : null
            }
        </>
    )
}